var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                ref: "queryCondition",
                staticClass: "searchForm",
                attrs: {
                  model: _vm.queryCondition,
                  "label-position": "right",
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "产品编码",
                                      prop: "fiveBitCode",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.fiveBitCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "fiveBitCode",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryCondition.fiveBitCode",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "产品中文名称",
                                      prop: "describe",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.describe,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "describe",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.describe",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "产品英文名称",
                                      prop: "fiveBitCodeName",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value:
                                          _vm.queryCondition.fiveBitCodeName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "fiveBitCodeName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryCondition.fiveBitCodeName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Category2",
                                      prop: "categoryLevel2CodeList",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          multiple: "",
                                          filterable: "",
                                          placeholder: "请选择(支持多选)",
                                        },
                                        on: { change: _vm.changeCategory2 },
                                        model: {
                                          value:
                                            _vm.queryCondition
                                              .categoryLevel2CodeList,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "categoryLevel2CodeList",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.categoryLevel2CodeList",
                                        },
                                      },
                                      _vm._l(
                                        _vm.categoryList2,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.code,
                                            attrs: {
                                              label: item.name,
                                              value: item.code,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-collapse-transition",
                      [
                        _vm.isShow
                          ? _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "Category3",
                                              prop: "categoryLevel3CodeList",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  multiple: "",
                                                  filterable: "",
                                                  placeholder:
                                                    "请选择(支持多选)",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .categoryLevel3CodeList,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "categoryLevel3CodeList",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.categoryLevel3CodeList",
                                                },
                                              },
                                              _vm._l(
                                                _vm.categoryList3,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.code,
                                                    attrs: {
                                                      label: item.name,
                                                      value: item.code,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "结算单位名称",
                                              prop: "supplierName",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticStyle: { width: "100%" },
                                              attrs: { clearable: "" },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .supplierName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "supplierName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.supplierName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "工厂名称",
                                              prop: "facilityName",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticStyle: { width: "100%" },
                                              attrs: { clearable: "" },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .facilityName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "facilityName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.facilityName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "状态",
                                              prop: "status",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                table: "TT_NUTR_INGREDIENT",
                                                field: "STATUS",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition.status,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "status",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.status",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "最新检测日期从",
                                              prop: "lastInspectDateBegin",
                                            },
                                          },
                                          [
                                            _c("el-date-picker", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                type: "date",
                                                "value-format": "yyyy-MM-dd",
                                                format: "yyyy-MM-dd",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .lastInspectDateBegin,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "lastInspectDateBegin",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.lastInspectDateBegin",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "最新检测日期至",
                                              prop: "lastInspectDateEnd",
                                            },
                                          },
                                          [
                                            _c("el-date-picker", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                type: "date",
                                                "value-format": "yyyy-MM-dd",
                                                format: "yyyy-MM-dd",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .lastInspectDateEnd,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "lastInspectDateEnd",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.lastInspectDateEnd",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "烹饪方式",
                                              prop: "cookCode",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                table: "TR_NUTR_GRI_COOK",
                                                field: "COOK_CODE",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition.cookCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "cookCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.cookCode",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "检测标识",
                                              prop: "needInspect",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                table: "TT_NUTR_INGREDIENT",
                                                field: "NEED_INSPECT",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .needInspect,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "needInspect",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.needInspect",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  {
                    attrs: { type: "flex", justify: "center", align: "middle" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.onSearch },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.onReset },
                      },
                      [_vm._v("重置")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "arrowDown",
                        on: {
                          click: function ($event) {
                            _vm.isShow = !_vm.isShow
                          },
                        },
                      },
                      [
                        _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                        _c("i", {
                          class: _vm.isShow
                            ? "el-icon-arrow-up iconBtn"
                            : "el-icon-arrow-down iconBtn",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          { staticClass: "action-btn-row" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.NEED_INSPECT_UPDATE,
                    expression: "NEED_INSPECT_UPDATE",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.onUpdate },
              },
              [_vm._v("更新检测标识")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.INSPECT_LAB_UPDATE,
                    expression: "INSPECT_LAB_UPDATE",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.onLabUpdate },
              },
              [_vm._v("更新检测实验室")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.INGREDIENT_EXPORT,
                    expression: "INGREDIENT_EXPORT",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.onDownload },
              },
              [_vm._v("导出")]
            ),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.tableData,
                  "max-height": "425",
                  border: "",
                  stripe: "",
                },
                on: { "selection-change": _vm.handleSelectionChange },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "fiveBitCode",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "fiveBitCode"),
                    "show-overflow-tooltip": "",
                    label: "产品编码",
                    width: "130",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm.isGo
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goPage(scope.row)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(scope.row.fiveBitCode))]
                              )
                            : _c("span", [
                                _vm._v(_vm._s(scope.row.fiveBitCode)),
                              ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "describe",
                    sortable: "",
                    "sort-method": (a, b) => _vm.sortMethods(a, b, "describe"),
                    "show-overflow-tooltip": "",
                    label: "产品中文名称",
                    width: "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "fiveBitCodeName",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "fiveBitCodeName"),
                    "show-overflow-tooltip": "",
                    label: "产品英文名称",
                    width: "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "supplierName",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "supplierName"),
                    "show-overflow-tooltip": "",
                    label: "结算单位名称",
                    width: "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "facilityName",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "facilityName"),
                    "show-overflow-tooltip": "",
                    label: "工厂名称",
                    width: "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "categoryLevel2Name",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "categoryLevel2Name"),
                    "show-overflow-tooltip": "",
                    label: "Category2",
                    width: "120",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "categoryLevel3Name",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "categoryLevel3Name"),
                    "show-overflow-tooltip": "",
                    label: "Category3",
                    width: "120",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "cookCodeText",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "cookCodeText"),
                    "show-overflow-tooltip": "",
                    label: "烹饪方式",
                    width: "120",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "statusText",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "statusText"),
                    "show-overflow-tooltip": "",
                    label: "状态",
                    width: "90",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "needInspectText",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "needInspectText"),
                    "show-overflow-tooltip": "",
                    label: "检测标识",
                    width: "120",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "adjustReason",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "adjustReason"),
                    "show-overflow-tooltip": "",
                    label: "修改原因",
                    width: "180",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "lastInspectDate",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "lastInspectDate"),
                    "show-overflow-tooltip": "",
                    label: "最新检测日期",
                    width: "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "inspectLabCodeText",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "inspectLabCodeText"),
                    "show-overflow-tooltip": "",
                    label: "检测实验室",
                    width: "180",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "remark",
                    sortable: "",
                    "sort-method": (a, b) => _vm.sortMethods(a, b, "remark"),
                    "show-overflow-tooltip": "",
                    label: "备注",
                    width: "180",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "updateDate",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "updateDate"),
                    "show-overflow-tooltip": "",
                    label: "更新日期",
                    width: "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "updateByName",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "updateByName"),
                    "show-overflow-tooltip": "",
                    label: "更新人",
                    width: "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "createDate",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "createDate"),
                    "show-overflow-tooltip": "",
                    label: "创建日期",
                    width: "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: { label: "操作", width: "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "acl",
                                  rawName: "v-acl",
                                  value: _vm.INGREDIENT_COMMENTS,
                                  expression: "INGREDIENT_COMMENTS",
                                },
                              ],
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.onRemark(scope.row)
                                },
                              },
                            },
                            [_vm._v("备注")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.queryCondition.pageNum,
                    "page-sizes": _vm.pageSizeList,
                    "page-size": _vm.queryCondition.pageSize,
                    layout: _vm.pageLayout,
                    total: _vm.totalCount,
                    "page-count": _vm.pages,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "更新检测标识",
              visible: _vm.dialogVisible,
              width: "30%",
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
              close: _vm.onClose,
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "testForm",
                attrs: {
                  model: _vm.testForm,
                  rules: _vm.testFormRules,
                  "label-width": "100px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "检测标识", prop: "needInspect" } },
                  [
                    _c("ic-select", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        table: "TT_NUTR_INGREDIENT",
                        field: "NEED_INSPECT",
                        clearable: "",
                      },
                      model: {
                        value: _vm.testForm.needInspect,
                        callback: function ($$v) {
                          _vm.$set(_vm.testForm, "needInspect", $$v)
                        },
                        expression: "testForm.needInspect",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "修改原因", prop: "adjustReason" } },
                  [
                    _c("el-input", {
                      attrs: { type: "textarea", rows: 2 },
                      model: {
                        value: _vm.testForm.adjustReason,
                        callback: function ($$v) {
                          _vm.$set(_vm.testForm, "adjustReason", $$v)
                        },
                        expression: "testForm.adjustReason",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              {
                staticStyle: { "margin-top": "10px" },
                attrs: { type: "flex", justify: "center" },
              },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: {
                      size: "mini",
                      type: "primary",
                      disabled: _vm.isSaveDisabled1,
                      loading: _vm.isSaveLoading1,
                    },
                    on: { click: _vm.onSaveTest },
                  },
                  [_vm._v("保存")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini" },
                    on: { click: _vm.onClose },
                  },
                  [_vm._v("取消")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "检测实验室维护",
              visible: _vm.dialogVisible1,
              width: "30%",
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible1 = $event
              },
              close: _vm.onCloseMain,
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "maintenanceForm",
                attrs: {
                  model: _vm.maintenanceForm,
                  rules: _vm.labRules,
                  "label-width": "100px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "检测实验室", prop: "inspectLabCode" } },
                  [
                    _c("ic-select", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        table: "TM_USER",
                        field: "LABORATORY",
                        clearable: "",
                      },
                      model: {
                        value: _vm.maintenanceForm.inspectLabCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.maintenanceForm, "inspectLabCode", $$v)
                        },
                        expression: "maintenanceForm.inspectLabCode",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              {
                staticStyle: { "margin-top": "10px" },
                attrs: { type: "flex", justify: "center" },
              },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: {
                      size: "mini",
                      type: "primary",
                      disabled: _vm.isSaveDisabled2,
                      loading: _vm.isSaveLoading2,
                    },
                    on: { click: _vm.onSaveLab },
                  },
                  [_vm._v("保存")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini" },
                    on: { click: _vm.onCloseMain },
                  },
                  [_vm._v("取消")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "备注",
              visible: _vm.dialogNoteVisible,
              width: "30%",
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogNoteVisible = $event
              },
              close: _vm.onCloseNote,
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "noteForm",
                attrs: {
                  model: _vm.noteForm,
                  rules: _vm.rules,
                  "label-width": "80px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "备注", prop: "remark" } },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 2,
                        maxlength: "500",
                        "show-word-limit": "",
                      },
                      model: {
                        value: _vm.noteForm.remark,
                        callback: function ($$v) {
                          _vm.$set(_vm.noteForm, "remark", $$v)
                        },
                        expression: "noteForm.remark",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              {
                staticStyle: { "margin-top": "10px" },
                attrs: { type: "flex", justify: "center" },
              },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: {
                      size: "mini",
                      type: "primary",
                      disabled: _vm.isSaveDisabled3,
                      loading: _vm.isSaveLoading3,
                    },
                    on: { click: _vm.onSaveNote },
                  },
                  [_vm._v("保存")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini" },
                    on: { click: _vm.onCloseNote },
                  },
                  [_vm._v("关闭")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }